import React, { useEffect, useState } from "react";
import { ArrowGlyph } from "./glyphs";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setMobileOpen(false);

  return (
    <nav className={"nav" + (scrolled ? " scrolled" : "")}>
      <a className="nav-brand" href="#top">
        <img className="nav-brand-mark" src="/h_logo.png" alt="Hridhayam" />
        <span>Hridhayam</span>
      </a>
      <div className="nav-links">
        <a className="nav-link" href="#features">Features</a>
        <a className="nav-link" href="#how">How it works</a>
        <a className="nav-link" href="#stories">Stories</a>
        <a className="nav-link" href="#about">About</a>
      </div>
      <a className="nav-cta" href="#download">
        Download <ArrowGlyph />
      </a>
      <button className="nav-burger" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu">
        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
          <path d="M1 2h16M1 7h16M1 12h16" />
        </svg>
      </button>
      {mobileOpen && (
        <div className="nav-mobile">
          <a href="#features" onClick={close}>Features</a>
          <a href="#how" onClick={close}>How it works</a>
          <a href="#stories" onClick={close}>Stories</a>
          <a href="#about" onClick={close}>About</a>
          <a href="#download" onClick={close} style={{ color: "var(--blue-deep)" }}>↳ Download</a>
        </div>
      )}
    </nav>
  );
}
